import type {
  RepositoryPickerRepository$data as Repository,
  RepositoryPickerRepositoryIssueTemplates$data as Templates,
} from '@github-ui/item-picker/repository'
import {Box, Link} from '@primer/react'
import {LABELS} from './constants'

type TemplateListPaneFooterProps = {
  repository: Repository
  templates: Templates
}

export const TemplateListPaneFooter = ({repository, templates}: TemplateListPaneFooterProps) => {
  const hasAnyTemplates = (templates.issueTemplates?.length ?? 0) > 0 || (templates.issueForms?.length ?? 0) > 0
  if (!hasAnyTemplates) {
    return null
  }

  const hyperlinkText = repository.viewerCanPush ? LABELS.editTemplates : LABELS.viewTemplates

  return (
    <Box sx={{pt: 3, alignItems: 'flex-start', textAlign: 'left'}}>
      <Link href={templates.templateTreeUrl} target="_blank">
        {hyperlinkText}
      </Link>
    </Box>
  )
}

try{ TemplateListPaneFooter.displayName ||= 'TemplateListPaneFooter' } catch {}